module.exports = __webpack_public_path__ + "media/images/lb/703-983e365fdf28a83ae0df9b60313bbe40.svg";